let searchTimer;
let lastQuery = '';

document.querySelectorAll('.header-search__input').forEach((input) => {
  input.addEventListener('input', function() {
    clearTimeout(searchTimer);

    searchTimer = setTimeout(() => {
      const query = this.value.trim();

      if (!query || query === lastQuery) return;
      lastQuery = query;

      gtag('event', 'search_bar_terms', {
        search_input: query
      });

    }, 650);
  });
});